import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import CapsuleInformation from '@repo/ui/capsule-information'

type Props = {
  attributedPlaces: number
  blockedPlaces: number
  total: number
  hideTotal?: boolean
}

export const CenterCapsuleInformation: React.FC<Props> = ({
  attributedPlaces,
  blockedPlaces,
  total,
  hideTotal
}) => (
  <CapsuleInformation
    hideTotal={hideTotal}
    items={[
      {
        background: tailwindColors.blue.light.active,
        color: tailwindColors.blue.DEFAULT,
        value: attributedPlaces,
        tooltip: 'Affectés'
      },
      {
        background: tailwindColors.fushia.light.active,
        color: tailwindColors.fushia.DEFAULT,
        value: blockedPlaces,
        tooltip: 'Bloqués'
      },
      {
        background: tailwindColors.green.light.active,
        color: tailwindColors.green.DEFAULT,
        value: total - attributedPlaces - blockedPlaces,
        tooltip: 'Restants'
      }
    ]}
  />
)
